import { designToken, quickProperty } from '../component-tokens';
import { focusState } from './common';
import { sizeAttributes } from './utils';
export const accordionData = {
    name: 'accordion',
    tag: 'chameleon-accordion',
    reactImports: 'Accordion, AccordionItem',
    attributes: {
        font: designToken('body-small'),
    },
    sizes: [
        {
            name: 'small',
            attributes: {
                font: designToken('caption-medium'),
            },
            children: [
                {
                    name: 'heading',
                    attributes: {
                        font: designToken('caption-medium'),
                    },
                },
                {
                    name: 'icon',
                    attributes: {
                        '--goto-icon-size': designToken('spacing-04'),
                    },
                },
            ],
        },
        {
            name: 'large',
            attributes: {
                font: designToken('body-medium'),
            },
            children: [
                {
                    name: 'heading',
                    attributes: {
                        font: designToken('body-medium'),
                    },
                },
            ],
        },
    ],
    children: [
        {
            name: 'item',
            attributes: {
                height: quickProperty('auto'),
                font: quickProperty('inherit'),
                'border-bottom': quickProperty('none'),
            },
        },
        {
            name: 'heading',
            attributes: {
                color: designToken('type-color-default'),
                height: quickProperty('auto'),
                'align-items': quickProperty('center'),
                display: quickProperty('grid'),
                position: quickProperty('relative'),
                'grid-template-columns': quickProperty('auto 1fr auto 40px'),
                border: quickProperty('1px solid transparent'),
            },
            states: [
                {
                    name: 'hover',
                    attributes: {
                        'background-color': designToken('interactive-color-secondary-hover'),
                    },
                },
                {
                    name: 'active',
                    attributes: {
                        'background-color': designToken('interactive-color-secondary-default'),
                    },
                },
                {
                    name: 'focus',
                    attributes: Object.assign(Object.assign({}, focusState), { outline: quickProperty('none') }),
                },
            ],
            children: [
                {
                    name: 'title',
                    attributes: {
                        color: designToken('type-color-default'),
                        font: designToken('body-small'),
                        height: quickProperty('2em'),
                        padding: quickProperty('0 1em'),
                    },
                },
            ],
        },
        {
            name: 'leading-icon',
            attributes: Object.assign(Object.assign({}, sizeAttributes('spacing-04', designToken)), { display: quickProperty('grid'), 'margin-left': designToken('spacing-04'), 'place-items': quickProperty('center') }),
        },
        {
            name: 'icon',
            attributes: {
                '--goto-icon-color': designToken('icon-color-default'),
                '--goto-icon-size': designToken('spacing-04'),
            },
        },
    ],
};
